import React, { useState } from 'react';
import axios from 'axios';
import { APIURL } from '../../Global';

const SelectAll = ({ NurseDetails1, NurseDetails, setNurseDetails }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSelectAll = async () => {
        setIsLoading(true);
        setError(null);
        const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const tokenString = sessionStorage.getItem("usertoken");
        let v2 = tokenString.replace(/["]+/g, "");
        
        try {
            const response = await axios.get(`${APIURL}/api/v1/service-provider/nurse/?timeZone=${currentTimezone}&assignee&selectall`, {
                headers: { Authorization: "Token " + v2 },
            });

            if (response.status === 200) {
                const newNurses = response.data.reduce((acc, nurse) => {
                    const existsInDetails = NurseDetails.some(item => item.id === nurse.user);
                    const existsInDetails1 = NurseDetails1.some(item => item.id === nurse.user);
                    
                    if (!existsInDetails && !existsInDetails1) {
                        acc.push({ id: nurse.user, name: nurse.name });
                    }
                    return acc;
                }, []);

                if (newNurses.length > 0) {
                    setNurseDetails([...NurseDetails, ...newNurses]);
                }
            }
        } catch (err) {
            setError('Failed to fetch nurses');
            console.error('Error fetching nurses:', err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
            <button
                onClick={handleSelectAll}
                disabled={isLoading}
                style={{height:'fit-content', backgroundColor:'#3C689E', color:'#fff', borderRadius:'4px'}}
            >
                {isLoading ? 'Loading...' : 'Select All'}
            </button>
    );
};

export default SelectAll;